import { ArrowRight } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconArrowRight(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ArrowRight />
    </IconWrapper>
  );
}
